import React, { useEffect, useState } from 'react';
import { db } from '../firebase/firebaseConfig';
import {
  collection,
  query,
  where,
  onSnapshot,
  addDoc,
  updateDoc,
  doc
} from 'firebase/firestore';
import { useAuth } from '../context/AuthContext';

const FoundItems = () => {
  const [foundItems, setFoundItems] = useState([]);
  const [claimingItemId, setClaimingItemId] = useState(null);
  const { currentUser } = useAuth();

  useEffect(() => {
    const fetchFoundItems = () => {
      const q = query(
        collection(db, 'foundItems'),
        where('reportType', '==', 'found')
      );

      const unsubscribe = onSnapshot(q, (snapshot) => {
        const items = snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
        const visibleItems = items.filter(item => !item.claimed || item.claimed === false);
        setFoundItems(visibleItems);
      });

      return () => unsubscribe();
    };

    fetchFoundItems();
  }, []);

  const handleClaim = async (item) => {
    if (!currentUser) {
      alert('Please log in to submit a claim.');
      return;
    }

    setClaimingItemId(item.id);

    try {
      await addDoc(collection(db, 'claims'), {
        claimedBy: currentUser.uid,
        claimedByName: currentUser.displayName || 'Anonymous',
        email: currentUser.email || '',
        studentEmail: currentUser.email || '',
        itemId: item.id,
        itemName: item.itemName || 'Unnamed Item',
        itemDescription: item.description || 'No description',
        location: item.location || 'Unknown location',
        dateFound: item.dateReported || null,
        reportType: item.reportType || '',
        imageUrl: item.imageUrl || '',
        matched: false,
        status: 'claim requested',
        submittedAt: new Date()
      });

      await updateDoc(doc(db, 'foundItems', item.id), {
        claimed: true,
        claimedBy: currentUser.email,
        claimedAt: new Date()
      });

      alert('✅ Claim submitted successfully!');
    } catch (error) {
      console.error('❌ Error submitting claim:', error);
      alert('❌ Could not submit claim. Please try again.');
    } finally {
      setClaimingItemId(null);
    }
  };

  const formatDate = (timestamp) => {
    if (!timestamp) return 'N/A';
    const date = timestamp.toDate ? timestamp.toDate() : new Date(timestamp);
    return date.toLocaleDateString();
  };

  return (
    <div>
      <h2>Found Items</h2>

      {foundItems.length === 0 ? (
        <p>No found items reported yet.</p>
      ) : (
        <ul>
          {foundItems.map((item) => (
            <li
              key={item.id}
              style={{
                border: '1px solid #ccc',
                marginBottom: '1rem',
                padding: '1rem',
                borderRadius: '8px',
              }}
            >
              <h3>{item.itemName || 'Unnamed Item'}</h3>

              {item.imageUrl && (
                <img
                  src={item.imageUrl}
                  alt={item.itemName || 'Found item image'}
                  style={{
                    width: '200px',
                    height: 'auto',
                    borderRadius: '5px',
                    marginBottom: '0.5rem',
                  }}
                />
              )}

              <p><strong>Description:</strong> {item.description || 'No description'}</p>
              <p><strong>Location:</strong> {item.location || 'Unknown location'}</p>
              <p><strong>Date Found:</strong> {formatDate(item.dateReported)}</p>
              <p><strong>Reported by:</strong> {item.yourName || 'Anonymous'}</p>
              <p><strong>Status:</strong> Found</p>
              <p><strong>Message:</strong> {item.message || 'No message provided.'}</p>

              <button
                onClick={() => handleClaim(item)}
                disabled={claimingItemId === item.id}
                style={{
                  padding: '0.5rem 1rem',
                  backgroundColor: '#1B3B6F',
                  color: 'white',
                  border: 'none',
                  borderRadius: '5px',
                  cursor: 'pointer',
                }}
              >
                {claimingItemId === item.id ? 'Submitting...' : 'Claim'}
              </button>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default FoundItems;
